module.exports = __webpack_public_path__ + "static/img/I.846d4b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/I.png
// module id = ZcGn
// module chunks = 1